/**
 * @name: marketingManagement.js
 * @description: 营销管理路由
 * @author: 于海威
 * @create: 2020/08/07 17:15:51
 * @update: 2020/08/07 17:15:51
 */

export default [
  {
    path: '/marketing/coupon/list',
    name: 'couponManagement',
    component: () => import('@/views/marketing/coupon/List'),
    meta: {
      title: '优惠券/码'
    }
  },
  {
    path: '/marketing/coupon/add',
    name: 'couponAdd',
    component: () => import('@/views/marketing/coupon/Add'),
    meta: {
      title: '新增优惠券',
      parentRoutePath: 'couponManagement'
    }
  },
  {
    path: '/marketing/coupon/grantrecord',
    name: 'grantRecord',
    component: () => import('@/views/marketing/coupon/GrantRecord'),
    meta: {
      title: '优惠券发放',
      parentRoutePath: 'couponManagement'
    }
  },
  {
    path: '/marketing/coupon/grant',
    name: 'couponGrant',
    component: () => import('@/views/marketing/coupon/Grant'),
    meta: {
      title: '发放优惠券',
      parentRoutePath: 'grantRecord'
    }
  },
  {
    path: '/marketing/coupon/grantdetail',
    name: 'couponGrantDetail',
    component: () => import('@/views/marketing/coupon/GrantDetail'),
    meta: {
      title: '优惠券发放详情',
      parentRoutePath: 'couponManagement'
    }
  },
  {
    path: '/marketing/discount/list',
    name: 'discountManagement',
    component: () => import('@/views/marketing/discount/List'),
    meta: {
      title: '折扣折价'
    }
  },
  {
    path: '/marketing/discount/add',
    name: 'discountAdd',
    component: () => import('@/views/marketing/discount/Add'),
    meta: {
      title: '增加折扣折价活动',
      parentRoutePath: 'discountManagement'
    }
  },
  {
    path: '/marketing/preferential/list',
    name: 'preferentialManagement',
    component: () => import('@/views/marketing/preferential/List'),
    meta: {
      title: '优惠活动'
    }
  },
  {
    path: '/marketing/preferential/add',
    name: 'preferentialAdd',
    component: () => import('@/views/marketing/preferential/Add'),
    meta: {
      title: '新增优惠活动',
      parentRoutePath: 'preferentialManagement'
    }
  },
  {
    path: '/marketing/advertise/list',
    name: 'advertiseManagement',
    component: () => import('@/views/marketing/advertise/List'),
    meta: {
      title: 'app广告配置'
    }
  },
  {
    path: '/marketing/advertise/config',
    name: 'advertiseConfig',
    component: () => import('@/views/marketing/advertise/Config'),
    meta: {
      title: 'app广告配置-配置广告',
      parentRoutePath: 'advertiseManagement'
    }
  },
  {
    path: '/marketing/advertise/add',
    name: 'advertiseAdd',
    component: () => import('@/views/marketing/advertise/Add'),
    meta: {
      title: 'app广告配置-添加广告',
      parentRoutePath: 'advertiseConfig'
    }
  },
  {
    path: '/marketing/exhibit/list',
    name: 'exhibitManagement',
    component: () => import('@/views/marketing/exhibit/List'),
    meta: {
      title: '门店陈列活动'
    }
  },
  {
    path: '/marketing/exhibit/apply',
    name: 'applyManagement',
    component: () => import('@/views/marketing/exhibit/Apply'),
    meta: {
      title: '提交门店列表',
      parentRoutePath: 'exhibitManagement'
    }
  },
  {
    path: '/marketing/exhibit/applydetail',
    name: 'applyStoreDetail',
    component: () => import('@/views/marketing/exhibit/ApplyDetail'),
    meta: {
      title: '提交门店详情',
      parentRoutePath: 'applyManagement'
    }
  },
  {
    path: '/marketing/exhibit/detail',
    name: 'exhibitDetail',
    component: () => import('@/views/marketing/exhibit/Detail'),
    meta: {
      title: '门店陈列活动详情',
      parentRoutePath: 'exhibitManagement'
    }
  },
];
